import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './pages/AuthProvider'; // Import AuthProvider and useAuth
import Sidebar from './pages/Sidebar';
import Login from './pages/Login';
import './index.css';
import Service from './pages/service';
import Blog from './pages/Blog';
import Contact from './pages/contact';
import Gallery from './pages/Gallery';
import Training from './pages/training';

const App = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="flex">
      {isAuthenticated && <Sidebar />}
      <main className="flex-grow">
        <Routes>
          {/* Public route */}
          <Route path="/" element={isAuthenticated ? <Navigate to="/blog" /> : <Login />} />
          
          {/* Protected routes */}
          <Route path="/blog" element={isAuthenticated ? <Blog /> : <Navigate to="/" />} />
          <Route path="/gallery" element={isAuthenticated ? <Gallery /> : <Navigate to="/" />} />
          <Route path="/contact" element={isAuthenticated ? <Contact /> : <Navigate to="/" />} />
          <Route path="/services" element={isAuthenticated ? <Service /> : <Navigate to="/" />} />
          <Route path="/training" element={isAuthenticated ? <Training /> : <Navigate to="/" />} />
        </Routes>
      </main>
    </div>
  );
};

ReactDOM.render(
  <AuthProvider>
    <Router>
      <App />
    </Router>
  </AuthProvider>,
  document.getElementById('root')
);
